import actions from "@/core/store/modules/services/actions";
import getters from "@/core/store/modules/services/getters";
import mutations from "@/core/store/modules/services/mutations";
export default {
    state: {
        service: {},
        activeService:null,
        buy_service:null
      },
    getters,
    mutations,
    actions
}